







































































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { filters } from "@/plugins/filters";
import { ProductDto } from "@/application/dtos/app/erp/v3/inventory/ProductDto";
import ErpService from "@/services/api/app/erp/ErpService";
import { ImageResolution } from "@/application/enums/app/common/ImageResolution";

@Component({})
export default class ProductTableRow extends Vue {
  @Prop({ default: -1 }) idx!: number;
  @Prop({ default: undefined }) item!: ProductDto;
  @Prop({ default: false }) allowRemove!: boolean;
  @Prop({ default: -1 }) withImageResolution!: ImageResolution;
  image: string = "";
  mounted() {
    if (this.withImageResolution >= 0) {
      ErpService.inventory.productImages
        .getImage(this.item.id, this.withImageResolution, 50)
        .then(response => {
          this.image = response;
          this.$forceUpdate();
        })
        .catch(() => {
          // console.error("ERROR: " + error);
        });
    }
  }
  moneyFormat(value) {
    return filters.moneyFormat(value);
  }
  totalStock(item: ProductDto) {
    let total = 0;
    item.stock.forEach(element => {
      total += element.quantity;
    });
    return filters.decimalFormat(total);
  }
  totalAmount(item: ProductDto) {
    let total = 0;
    item.stock.forEach(element => {
      total += element.quantity * item.unitPrice;
    });
    return filters.moneyFormat(total);
  }
}
